// Hook odpowiedzialny za pobranie powodów zwrotów i reklamacji

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse,
  ISearchRequest
} from 'api/types';

export interface IReturnsComplaintReasons {
  id: number,
  name: string,
  description: string
}

// parametry requestu do api
export type IRequest = IPaginationRequest & ISearchRequest;

// typ zwracanych danych
type IResponse = IPaginationResponse<IReturnsComplaintReasons>;

const getReturnsComplaintReasons = (params?: IRequest): Promise<IResponse> => axios.get('/return-complain/reasons', { params });

export const useGetReturnsComplaintReasons = (params?: IRequest, options?: UseQueryOptions<IResponse, IError>) =>
  useQuery<IResponse, IError>(['reasons', params], () => getReturnsComplaintReasons(params), options)
